import { all, call } from 'redux-saga/effects';
import { sagas as list } from './listModule';
import { sagas as details } from './detailsModule';

export default function* assetSaga() {
	yield all([call(list), call(details)]);
}
